import FullPageError from "./FullPageError";

export default FullPageError;
